const DIRECTIONS_TO_REACH = "INSTRUCTION_TYPE_REACH";
const FTUE_BENEFIT_TEXT_COUNT = 3;
const FTUE_NEW_TAG_COUNT = 3;
const BENEFIT_TEXT_KEY = "cart_delivery_instruction_benefit_text";
const VOICE_DIRECTION_TOOLTIP_KEY = "cart_voice_direction_tooltip";
const VOICE_DIRECTION_TOOLTIP_COUNT = 3;
const INSTRUCTOR_TEXT_PREFIX = "Delivery partner will ";

export {
    DIRECTIONS_TO_REACH,
    FTUE_BENEFIT_TEXT_COUNT,
    FTUE_NEW_TAG_COUNT,
    VOICE_DIRECTION_TOOLTIP_KEY,
    VOICE_DIRECTION_TOOLTIP_COUNT,
    BENEFIT_TEXT_KEY,
    INSTRUCTOR_TEXT_PREFIX,
};

export enum AddressFields {
    ADDRESS = "ADDRESS",
    ANNOTATION = "ANNOTATION",
    AREA = "AREA",
    MOBILE = "MOBILE",
    INSTRUCTIONS = "INSTRUCTIONS",
    FLAT_NO = "FLAT_NO",
    LANDMARK = "LANDMARK",
}

export const NO_ADDRESS_SELECTED_POPUP_DATA = {
    icon: "unified-discounting/CouponCartToastError",
    title: "No address selected!",
    description: "Please select an address before adding directions to reach",
    cta: {
        text: "Got It!",
        color: "#fc801a",
    },
};

/* TODO @HIMANSHU @SURYA: Remove this once the backend deployment includes this correct URLs */
export const DELIVERY_INSTRUCTIONS_ICONS = {
    "1": {
        active: "4_0_Assets/Delivery_Instructions/DTR_Active_ux4",
        inactive: "4_0_Assets/Delivery_Instructions/DTR_Inactive",
    },
    "2": {
        active: "4_0_Assets/Delivery_Instructions/Door_Grey_Active_ux4",
        inactive: "4_0_Assets/Delivery_Instructions/Door_Grey_Inactive.png",
    },
    "3": {
        active: "4_0_Assets/Delivery_Instructions/Do_Not_Call_Active_ux4",
        inactive: "4_0_Assets/Delivery_Instructions/Do_Not_Call_Inactive.png",
    },
    "4": {
        active: "4_0_Assets/Delivery_Instructions/Door_Bell_Active_ux4",
        inactive: "4_0_Assets/Delivery_Instructions/Door_Bell_Inactive.png",
    },
    "5": {
        active: "4_0_Assets/Delivery_Instructions/Security_Active_ux4",
        inactive: "4_0_Assets/Delivery_Instructions/Security_Inactive.png",
    },
};

/* TODO @HIMANSHU @SURYA: Remove this once the backend deployment includes this correct URLs */
export const POP_DELIVERY_INSTRUCTIONS_ICONS = {
    "1": {
        active: "Sunshine/cart/Cafe33_assets/microphone_filled_selected.png",
        inactive: "Sunshine/cart/Delivery_instruction/microphone_filled_unselected.png",
    },
    "2": {
        active: "Sunshine/cart/Cafe33_assets/Door_Grey_selected.png",
        inactive: "Sunshine/cart/Delivery_instruction/Door_Grey_unselected.png",
    },
    "3": {
        active: "Sunshine/cart/Cafe33_assets/Avoid_calling_up_selected.png",
        inactive: "Sunshine/cart/Delivery_instruction/Avoid_calling_up_unselected.png",
    },
    "4": {
        active: "Sunshine/cart/Cafe33_assets/Bell_icon_selected.png",
        inactive: "Sunshine/cart/Delivery_instruction/Bell_icon_unselected.png",
    },
    "5": {
        active: "Sunshine/cart/Cafe33_assets/Security_Grey_selected.png",
        inactive: "Sunshine/cart/Delivery_instruction/Security_Grey_unselected.png",
    },
};

/* TODO @HIMANSHU @SURYA: Remove this once the backend deployment includes this correct URLs */
export const TOING_DELIVERY_INSTRUCTIONS_ICONS = {
    "1": {
        active: "Toing/Cart%20Page/mic_green.png",
        inactive: "Toing/Cart%20Page/mic_gray.png",
    },
    "2": {
        active: "Toing/Cart%20Page/door-green.png",
        inactive: "Toing/Cart%20Page/door-gray.png",
    },
    "3": {
        active: "Toing/Cart%20Page/calling-green.png",
        inactive: "Toing/Cart%20Page/calling-gray.png",
    },
    "4": {
        active: "Toing/Cart%20Page/bell-green.png",
        inactive: "Toing/Cart%20Page/bell-gray.png",
    },
    "5": {
        active: "Toing/Cart%20Page/security-green.png",
        inactive: "Toing/Cart%20Page/security-gray.png",
    },
};

export const DELIVERY_INSTRUCTIONS = "Delivery Instructions";
